import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';
import { PostItemMediaItem } from '@/types/residents/marketplaceListing';
import { MediaCarouselUpload } from '@/components/common/residents/MediaCarouselUpload';
import { StepHeader, postItemStyles } from './shared';

const UPLOAD_AREA_HEIGHT = 281;
const MAX_PHOTOS = 10;
const MAX_FILE_SIZE_MB = 2;

interface StepMediaProps {
  mediaItems: PostItemMediaItem[];
  onMediaItemsChange: (items: PostItemMediaItem[]) => void;
  title?: string;
}

const CameraIcon: React.FC = () => {
  const MARKETPLACE_COLORS = useMarketplaceColors();

  return (
    <View style={styles.cameraIconContainer}>
      <View style={styles.cameraIcon}>
        <View style={[styles.cameraBody, { borderColor: MARKETPLACE_COLORS.inputBorder }]} />
        <View style={[styles.cameraLens, { borderColor: MARKETPLACE_COLORS.inputBorder }]} />
      </View>
      <View style={styles.plusIcon}>
        <View style={[styles.plusVertical, { backgroundColor: MARKETPLACE_COLORS.inputBorder }]} />
        <View style={[styles.plusHorizontal, { backgroundColor: MARKETPLACE_COLORS.inputBorder }]} />
      </View>
    </View>
  );
};

export const StepMedia: React.FC<StepMediaProps> = ({
  mediaItems,
  onMediaItemsChange,
  title = 'Add photo or video',
}) => (
  <View style={postItemStyles.container}>
    <StepHeader title={title} />
    <View style={postItemStyles.content}>
      <MediaCarouselUpload
        files={mediaItems}
        onFilesChange={onMediaItemsChange as any}
        config={{
          maxFiles: MAX_PHOTOS,
          maxFileSizeMB: MAX_FILE_SIZE_MB,
          acceptedTypes: 'image/jpeg,image/png,image/gif,image/webp',
          uploadAreaHeight: UPLOAD_AREA_HEIGHT,
        }}
        variant="dark"
        showChevrons
        icon={<CameraIcon />}
        imagesOnly
        requestCameraPermission
      />
    </View>
  </View>
);

const styles = StyleSheet.create({
  cameraIconContainer: {
    width: 48,
    height: 48,
    position: 'relative',
  },
  cameraIcon: {
    width: 48,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
  },
  cameraBody: {
    width: 36,
    height: 28,
    borderWidth: 2,
    borderRadius: 4,
    position: 'relative',
  },
  cameraLens: {
    position: 'absolute',
    width: 14,
    height: 14,
    borderWidth: 2,
    borderRadius: 7,
  },
  plusIcon: {
    position: 'absolute',
    right: 0,
    top: 7,
    width: 13,
    height: 13,
  },
  plusVertical: {
    position: 'absolute',
    left: 5,
    top: 0,
    width: 2.5,
    height: 12.5,
    borderRadius: 3,
  },
  plusHorizontal: {
    position: 'absolute',
    left: 0,
    top: 5,
    width: 12.5,
    height: 2.5,
    borderRadius: 3,
  },
});
